export const KEY_EVENT_CALIBRATION = 'KEY_EVENT_CALIBRATION'
export const GRID_SIZE = 6
export const BUTTONS_HEADER_HEIGHT = 3
export const DEFAULT_SELECT_SENSOR = { id: 0, nome: 'Sensor' }
export const DEFAULT_SELECT_USUARIO = { nome: 'Usuário' }
export const EMPTY_TRACE_CALIBRATION = { type: 'bar', orientation: 'h', base: [1], x: [1], y: [''] }

export const getCalibrationKey = (mastId: number) => [KEY_EVENT_CALIBRATION, mastId]
